import Vue from "vue"
import { mapState } from "vuex"

export default Vue.extend({
  computed: {
    ...mapState("app", ["menu", "event"]),

    socials (): [string, string][] {
      if (this.$i18n.locale === "ru")
        return [
          ["max", "https://max.ru/wyffest"],
          ["vkontakte", "https://vk.com/wyf"],
          ["telegram", "https://t.me/wyffest"],
        ]
      else
        return [
          ["max", "https://max.ru/wyffest"],
          ["vkontakte", "https://vk.com/wyf"],
          ["telegram", "https://t.me/wyffest_en"],
        ]
    },
  },
})
